import { GetterTree } from 'vuex'
import BrandsState from "../types/BrandsState";

export const getters: GetterTree<BrandsState, any> = {
  getBrands: state => state.brands
}
